import { Gallery, Item } from 'react-photoswipe-gallery';
import * as React from 'react';
export default {
  Gallery,
  Item,
  React
};